export const getUniqueLGAs = (addressList = []) => {
  var addresses = addressList || [];

  return [
    ...new Set(
      addresses
        .map(add => add.lga)
    )
  ];
};

export default getUniqueLGAs;
